import { render, staticRenderFns } from "./Delegations.vue?vue&type=template&id=77d62bb7&"
import script from "./Delegations.vue?vue&type=script&lang=js&"
export * from "./Delegations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports